// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import axios from "axios";
import router from "./router";
import store from "./store/index";
import tools from "./utils/tools.js";
import iView from "iview"; // 导入组件库
import "iview/dist/styles/iview.css"; // 导入样式
import api from "@/request/api.js"; // 导入api接口
import "./components/fontsvg/iconfont.js";
import "./components/fontsvg/iconfont.css";

import * as echarts from "echarts";
Vue.prototype.$echarts = echarts;

Vue.use(iView);
Vue.config.productionTip = false; // 阻止启动生产消息
Vue.prototype.tools = tools; // 通用方法
Vue.prototype.$api = api; // 接口

Vue.prototype.$http = axios; // 临时处理

Vue.prototype.$sessionToken = () => sessionStorage.token; // 临时处理

Vue.prototype.$bus = new Vue();

AMapLoader.load({
  key: "21278ebeb8e3284c136ed437f4cc617c", // 申请好的Web端开发者Key，首次调用 load 时必填
  version: "1.4.15", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
  plugins: ["AMap.Geocoder"], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
  AMapUI: {
    // 是否加载 AMapUI，缺省不加载
    version: "1.1", // AMapUI 缺省 1.1
    plugins: ["overlay/SimpleMarker"] // 需要加载的 AMapUI ui插件
  },
  Loca: {
    // 是否加载 Loca， 缺省不加载
    version: "1.3.2" // Loca 版本，缺省 1.3.2
  }
}).then(AMap => {
  window.AMap = AMap;
});

// 处理按钮权限
Vue.directive("access", {
  inserted: (el, binding) => {
    let menus = window.sessionStorage.getItem("menus");
    menus = JSON.parse(decodeURIComponent(menus));
    const buttonAccess = menus.reduce((prev, curr) => {
      if (!curr.url.includes("/")) {
        prev = prev.concat(curr.url);
      }
      return prev;
    }, []);
    if (!buttonAccess.includes(binding.value)) {
      el.parentNode.removeChild(el);
    }
  }
});

new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js